import React from 'react';
import { Layout, Empty, Modal, Tabs, Row, Col } from 'antd';

import { AdmsAsset, IEPActions } from '../../redux';
import { getNameAsset } from '../../components/adms/helper';
import AssetData from '../../components/adms/AssetData'
import EMDGraph from '../../components/emd/EMDGraph'
import { PackInfoExchageActions } from '../../actions'
import { ui } from '../../components/adms/helper'
import UMLDiagramm from '../../components/emd/popUpUML'
import XSDDiagramm from '../../components/emd/popUpXSD'
import CLMDiagramm from '../../components/emd/popUpCLM'
import DiagramGallery from '../../components/iep/DiagramGallery'
import XSDViewer from '../../components/iep/XSDViewer'
import WSDLViewer from '../../components/iep/WSDLViewer'
import TaxonomyCard from '../../components/skos/TaxonomyValues'
import { LoadingComponent } from '../../utils/ui';
//import SVG from 'react-inlinesvg';

import {responseIEPContent} from './../../simbix/demo-response';

const TabPane = Tabs.TabPane;
const catalog = "http://hbz.ru/adms/catalog";

//Отображение карточки 
const AssetTitle = names => {
  const single = names.length = 1;
  return (single)? names[0]: <span>names.map(name=> <p>{name}</p>)</span>;
}
const AssetDataProxy = ({values, lang, factory}) => 
<div className="csi_wrapper_content csi_inner_asset">
<Row>
    <Col className="asset_title" span={24}>{AssetTitle(getNameAsset(values, lang))}</Col>
</Row>
<Row>
    <Col className="assetCardTable" span={16}><AssetData operation="view" factory={factory}/> </Col>
    <Col className="properties_panel_wrapper" span={8}><TaxonomyCard operation="view" predicat="http://www.w3.org/ns/dcat#theme" factory={factory} /></Col>
</Row>
</div>            

const EMDGraphProxy = ({content}) => <EMDGraph content={responseIEPContent} />
//const IEPXSDProxy = ({}) => <SVG src="http://localhost:9009/ipo.svg" style={{height:2038, width: 1391}} />
const iframe = '<iframe src="http://localhost:9009/ipo.svg" width="540" height="450"></iframe>'; 

//const IEPXSDProxy = ({}) => <div><div dangerouslySetInnerHTML="<iframe src='http://localhost:9009/ipo.svg' width='540' height='450'></iframe>" /></div>
const IEPXSDProxy = ({}) => <div><iframe src="http://csi.hbz.local/_data/stamm.svg" style={{height: 400, width: "100%"}} ></iframe></div>
const IEPDumpProxy =({}) => <LoadingComponent />

const DumpProxy = () => <div>  <Empty description="Выберите пакет информационного обмена." /></div>
const decodeIRIParams = match =>{
  return (match && match.params && match.params.id)?decodeURIComponent(match.params.id):null;
}

//Компонента отображения содержания пакета информационного обмена.
//Включая отображения
class IEPCard extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        const {selected} = props
        this.state = {
            visible: false,       //Отображаемое модальное окно
            loaded: false, 			  //Флаг загрузки (загрузка как карточки, так и содержимого ЕМД)
            action: undefined,    //Полняемое действия для модального окна
						operation: "view",    //Текущая операция над карточкой
						content: undefined,		//Содержимое пакета в виде ответа SPARQL
						vowl: undefined,			//Содержимое пакета в виде VOWL
        }
        this.onChangeView = this.onChangeView.bind(this);
    }
    
		static getDerivedStateFromProps(props, state) {
			//console.log("IEPCard.js static getDerivedStateFromProps(props, state)", decodeIRIParams(props.match), props.IRI, props.state, props, state);
			if ((decodeIRIParams(props.match)!=props.IRI)||(props.state=="empty") || !props.IRI ) { //|| !props.content
				return {loaded: false, operation: "view", detail: undefined, visible: false, content: undefined, vowl: undefined};
			}
			if ((decodeIRIParams(props.match)==props.IRI)||(props.state=="loaded")){
				//При переключении Tabs onChangeView после вызывается getDerivedStateFromProps и сбрасывает visible
				const visible = ["VOWL", "UML", "XSD", "CLM", "DETAIL"].includes(state.action);
				return { ...state, loaded: true, visible};
			}
			return null; // Return null to indicate no change to state.
		}
	
    componentDidMount() { 
			const IRI = decodeIRIParams(this.props.match);
			if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty"))
				return this.props.onReload(AdmsAsset, IEPActions, catalog, IRI);
		}

		componentDidUpdate(prevProps, prevState) {
			const IRI = decodeIRIParams(this.props.match);
			if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
				return this.props.onReload(AdmsAsset, IEPActions, catalog, IRI);
		}

    showModal = (rectd, text) => {
        this.setState({visible: true, action: text});
    };
    
    handleOk = e => {
        console.log(e);
        this.setState({visible: false});
    };

    //Событие об изменения формы отображения выбранной версии ЕМД
    onChangeView(e) {
      //e.preventDefault(); //console.log(`IEPCard.js radio checked:${e}`);
      const {IRI, content, onReload} = this.props;
      const {vowl} = this.state;
      if (!content){
        return onReload(AdmsAsset, IEPActions, catalog, IRI)
          .then (response => {
//            this.setState({visible: true, action:"VOWL"});	
          })
      } 
      // if (!vowl || !Array.isArray(vowl.class) || (vowl.class.length <1))
      //   this.setState({visible: true, action:"VOWL"});
    }
    
    render() {
        console.log(this);
        const {loaded, vowl} = this.state
        const {IRI, values, lang, factory} = this.props
        const props = { content: vowl, IRI, values, lang, factory};
        return (
            (!loaded? <div>Загрузка</div>:
                <div>
                    <Row>
                        <Col span={24}>
{!IRI? <DumpProxy {...props} />:
<Tabs onChange={this.onChangeView} type="card">
    <TabPane tab="Карточка" key="card">
        <AssetDataProxy {...props} />
    </TabPane>
    <TabPane tab="OWL" key="graph">
        <EMDGraphProxy {...props} />
    </TabPane>
    <TabPane tab="XSD" key="xsd">
        <XSDViewer {...props} />
    </TabPane>
    <TabPane tab="WSDL" key="wsdl">
        <WSDLViewer {...props} />
    </TabPane>
    <TabPane tab="UML" key="uml">
        <DiagramGallery {...props} />
    </TabPane>
  </Tabs>
}  
                        </Col>
                    </Row>

        <Modal title="Элемент ЕМД" visible={this.state.visible} onOk={this.handleOk} cancelButtonProps={{ disabled: true }}>
            {(this.state.action=="UML")&&<UMLDiagramm />}
            {(this.state.action=="XSD")&&<XSDDiagramm />}
            {(this.state.action=="CLM")&&<CLMDiagramm />}                        
        </Modal>
                </div>            
            )
        )
    }
}

export default IEPCard;